import React from 'react';
import PropTypes from 'prop-types';

import { VpButton, VpConditionalUpgradeWrapper } from '../../';
import { PLUGIN_MANAGEMENT_ENABLED } from '../../../constants/feature-keys';

export const VpAdjustPluginVideoButton = ({ includeAttachments }) => {
  return (
    <VpConditionalUpgradeWrapper fullWidth featureKey={PLUGIN_MANAGEMENT_ENABLED}>
      {({ isDisabled }) => (
        <VpButton
          disabled={isDisabled}
          fullWidth
          variant="contained"
          name="adjustPluginVideosButton"
          type="submit"
          color="neutral"
        >
          {includeAttachments ? 'Adjust Content Displayed' : 'Adjust Videos Displayed'}
        </VpButton>
      )}
    </VpConditionalUpgradeWrapper>
  );
};

VpAdjustPluginVideoButton.propTypes = {
  includeAttachments: PropTypes.bool
};

export default VpAdjustPluginVideoButton;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/VpAdjustPluginVideoButton.jsx